define('root/app_store/Podio.UI.AppStore.ListView',['require','underscore','jquery','lib/jquery/jquery.pager','lib/Podio.Transport','lib/Podio.Routes'],function(require) {

  var _ = require('underscore');
  var $ = require('jquery');
  var jqueryPager = require('lib/jquery/jquery.pager');
  var transport = require('lib/Podio.Transport');
  var routes = require('lib/Podio.Routes');

  function ListView(elmListView, options) {

    _.bindAll(this, 'onPagerChanged', 'onSortingChanged');

    this.elmListView = elmListView;
    this.elmAppList = this.elmListView.find('.list-wrapper');
    this.elmHeaderBar = this.elmListView.find('.header-bar');
    this.elmPager = this.elmListView.find('.pager');

    this.pageSize = options.pageSize;
    this.state = options.state;
    this.shareType = options.shareType;
    this.refType = options.refType;
    this.refId = options.refId;

    this.sorting = this.sorting;

    this.shouldInictialHide = options.initialHide;


    this.elmListView.find('.pagination-sort-select').bind('change.listview', this.onSortingChanged);

  }

  _.extend(ListView.prototype, {

    getPage : function(pageOffset) {

      var self = this;
      var state = this.state;

      var elmExistingAppList = this.elmAppList.find('*[data-offset=' + pageOffset + ']');

      var direction = (parseInt(pageOffset, 10) < parseInt( state.offset.current, 10)) ? 1 : -1;

      if (this.elmAppList.find('ul').length > 0) {
        this.elmAppList.css('opacity', 0.6);
      }


      var url = routes.json_shares_list_path(this.shareType, this.refType, encodeURIComponent(this.refId));
      var req = transport.getJSON(url, {
        requestData : {
          sorting : this.sorting,
          offset: pageOffset,
          limit: this.pageSize
        }
      });


      var onReqComplete = _.bind(function(responseData) {

        if (responseData.data.count > 0) {

          if (elmExistingAppList.length && !this.shouldInitialHide) {
            this.elmAppList.show();
            this.elmHeaderBar.show();
          }

        } else if ( this.refType !== 'search' && this.refType !== 'own') {
          this.elmAppList.hide();
          this.elmHeaderBar.hide();
          return;
        }

        var elmNextPage = $(responseData.data.html);
        var appListWidth = this.elmAppList.find('ul.list').outerWidth();

        if (elmExistingAppList.length > 0) {
          elmNextPage = elmExistingAppList;
        } else {
          elmNextPage.appendTo(this.elmAppList);
        }

        // Sort DOM nodes, to ensure proper order by offset
        var elmAppLists = this.elmAppList.children().detach();
        elmAppLists.sort(function(a,b) {
          var akey = $(a).data('offset');
          var bkey = $(b).data('offset');
          if (akey === bkey) {
            return 0;
          } else if (akey < bkey) {
            return -1;
          } else {
            return 1;
          }
        });

        elmAppLists.appendTo( this.elmAppList );

        // Stay at currentList, even after sorting has completed, by updating marginLeft
        var elmCurrentList = this.elmAppList.find('*[data-offset={0}]'.format(this.state.offset.current));
        var currentListIndex = elmCurrentList.index();
        var marginLeft = (appListWidth * currentListIndex) * -1;
        self.elmAppList.css('marginLeft', marginLeft);

        // Update state
        this.state.offset.current = pageOffset;

        if (!responseData.data.offsetPrev) {
          state.offset.prev = responseData.data.offsetPrev;
        } else {
          state.offset.prev = 0;
        }
        if (!responseData.data.offsetNext) {
          state.offset.next = responseData.data.offsetNext;
        } else {
          state.offset.next = 0;
        }

        var currentPageNumber = (state.offset.current / responseData.data.pageSize) + 1;
        var totalPageNumber = responseData.data.totalPageCount;

        // Render pagination
        this.elmPager.pager({
          pagenumber: currentPageNumber,
          pagecount: totalPageNumber,
          buttonClickCallback: this.onPagerChanged
        });

        // Carousel scrolling
        var nextPageIndex = elmNextPage.index();
        var marginLeftOffset = (appListWidth * nextPageIndex) * -1;

        this.elmAppList.animate({ 'marginLeft': marginLeftOffset }, 500, 'easeInOutExpo', function() {
          self.elmAppList.css('opacity', '');
        });

        // Show stuff
        this.showComponents();

      }, this);


      req.done( onReqComplete );

      return req;
    },

    onSortingChanged: function(e) {

      var elmTarget = $(e.currentTarget);

      // Loader
      this.elmAppList.css({
        width : this.elmListView.width(),
        height: this.elmAppList.height()
      });

      this.elmAppList.addClass('loading-overlay-big');

      // Cleaning
      this.elmAppList.find('ul.list').remove();

      // Set sorting
      this.sorting = elmTarget.val();

      // Go to first page
      this.getPage(0);
    },

    showComponents: function() {

      if (this.elmAppList.children().length) {
        this.elmAppList.show();
      }

      this.elmAppList.css({
        'width' : '',
        'height': ''
      });

      this.elmAppList.removeClass('loading-overlay-big');

    },

    onPagerChanged: function(pageNumber) {

      pageNumber = parseInt(pageNumber, 10);
      var offset = this.pageSize * (-1 + pageNumber);

      this.getPage(offset);

    }


  });


  return ListView;

});


